export { createTemporaryDOM, virtualizeDOM, updateDOM, hasChanged, parseDirectives, createElement, isEventProp, setProp, setProps, removeProp, updateProps, emptyElement } from './dom.functions';
export { exec } from './exec.function';
export { templater } from './templater.function';
export { using } from './using.function';